module.exports = __webpack_public_path__ + "asset/image-ic_category_31-10c682bd2a27a73c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_31.svg
// module id = G7hY
// module chunks = 0